import script from "./messagePage.vue?vue&type=script&setup=true&lang=js"
export * from "./messagePage.vue?vue&type=script&setup=true&lang=js"

import "./messagePage.vue?vue&type=style&index=0&id=3115b740&lang=less"

const __exports__ = script;

export default __exports__